export default function ColorStyle() {
  const TABLE = [
    { blue: "#4b59b7", red: "#be5c4e", yellow: "#a39c43" },
    { blue: "#171717", red: "#171717", yellow: "#171717" },
    { blue: "#242a51", red: "#582d27", yellow: "#3d3b1b" },
    { blue: "#515fba", red: "#c16254", yellow: "#a69f48" },
    { blue: "#6678ea", red: "#f17a69", yellow: "#d6cd5d" },
    { blue: "#566ae7", red: "#ee6b58", yellow: "#d3c94e" },
    { blue: "#2d3358", red: "#5f3630", yellow: "#444122" },
    { blue: "#414a8a", red: "#913022", yellow: "#766f1c" },
    { blue: "#5d70e8", red: "#ef7160", yellow: "#d4ca55" },
    { blue: "#4f5db9", red: "#c06052", yellow: "#a59e46" },
    { blue: "#0a0a0a", red: "#0a0a0a", yellow: "#0a0a0a" },
    { blue: "#434c8b", red: "#925046", yellow: "#777339" },
    { blue: "#586be8", red: "#ef6d5a", yellow: "#d4cb50" },
    { blue: "#3e4888", red: "#8f4b41", yellow: "#746f35" },
    { blue: "#161616", red: "#161616", yellow: "#161616" },
    { blue: "#21284f", red: "#562924", yellow: "#43401c" },
    { blue: "#202020", red: "#202020", yellow: "#202020" },
    { blue: "#596de8", red: "#ef6d5c", yellow: "#d4ca51" },
    { blue: "#4352b4", red: "#bb5445", yellow: "#a0993b" },
    { blue: "#4958b6", red: "#bd5a4c", yellow: "#a29b41" },
    { blue: "#6476e9", red: "#f07867", yellow: "#d5cc5b" },
    { blue: "#3f4fb3", red: "#ba5041", yellow: "#9f9737" },
    { blue: "#5462bb", red: "#c26457", yellow: "#a7a04b" },
    { blue: "#4d62e6", red: "#ed634f", yellow: "#d2c846" },
    { blue: "#384284", red: "#8b453b", yellow: "#706b2f" },
    { blue: "#212121", red: "#212121", yellow: "#212121" },
    { blue: "#4756b6", red: "#bd584a", yellow: "#a29a3f" },
    { blue: "#2d387e", red: "#853a2f", yellow: "#6a6525" },
    { blue: "#4554b5", red: "#bc5647", yellow: "#a19a3d" },
    { blue: "#2f3a7f", red: "#863c31", yellow: "#6b6627" },
    { blue: "#4150b3", red: "#ba5243", yellow: "#9f9839" },
    { blue: "#2f355a", red: "#613832", yellow: "#464324" },
    { blue: "#4f64e6", red: "#ed6451", yellow: "#d2c848" },
    { blue: "#3d4db2", red: "#b94e3f", yellow: "#9e9636" },
    { blue: "#323c80", red: "#873f35", yellow: "#6c672a" },
    { blue: "#5267e7", red: "#ee6754", yellow: "#d3c94a" },
    { blue: "#2a3157", red: "#5e332d", yellow: "#434020" },
    { blue: "#131313", red: "#131313", yellow: "#131313" },
    { blue: "#3a4486", red: "#8d473d", yellow: "#726d31" },
    { blue: "#181f48", red: "#4f201a", yellow: "#353211" },
    { blue: "#282f55", red: "#60332d", yellow: "#454220" },
    { blue: "#1a214a", red: "#51221c", yellow: "#373413" },
    { blue: "#070707", red: "#070707", yellow: "#070707" },
    { blue: "#5468e7", red: "#ee6956", yellow: "#d3c94c" },
    { blue: "#1f1f1f", red: "#1f1f1f", yellow: "#1f1f1f" },
    { blue: "#5165e7", red: "#ee6753", yellow: "#d3c949" },
    { blue: "#29347b", red: "#82362b", yellow: "#676222" },
    { blue: "#343e82", red: "#894137", yellow: "#6e692c" },
    { blue: "#060606", red: "#060606", yellow: "#060606" },
    { blue: "#687aea", red: "#f17b6b", yellow: "#d6cd5f" },
    { blue: "#1f264d", red: "#542722", yellow: "#3a3717" },
    { blue: "#262c53", red: "#5a2f29", yellow: "#3f3d1d" },
    { blue: "#5361ba", red: "#c16356", yellow: "#a69f4a" },
    { blue: "#3b4bb1", red: "#b84c3d", yellow: "#9d9534" },
    { blue: "#5f72e9", red: "#f07362", yellow: "#d5cb57" },
    { blue: "#4d5bb8", red: "#bf5e50", yellow: "#a49d45" },
    { blue: "#151515", red: "#151515", yellow: "#151515" },
    { blue: "#191919", red: "#191919", yellow: "#191919" },
    { blue: "#141414", red: "#141414", yellow: "#141414" },
    { blue: "#6275e9", red: "#f07665", yellow: "#d5cc59" },
    { blue: "#5b6fe8", red: "#ef6f5e", yellow: "#d4ca53" },
    { blue: "#111111", red: "#111111", yellow: "#111111" },
    { blue: "#3c4687", red: "#8e493f", yellow: "#736e33" },
    { blue: "#1d234c", red: "#53261f", yellow: "#393613" },
    { blue: "#364083", red: "#8a4339", yellow: "#6f6a2e" },
    { blue: "#2b367c", red: "#83382d", yellow: "#686324" },
    { blue: "#6173e9", red: "#f07564", yellow: "#d5cc59" },
  ];

  const cssRules = TABLE.map(({ blue }) => {
    return `svg :where(path[fill="${blue}"]) { fill: var(--m-${blue.replace(
      "#",
      ""
    )}) !important; }`;
  }).join("\n");

  const blueVars = TABLE.map(
    ({ blue }) => `--m-${blue.replace("#", "")}:${blue};`
  ).join("\n");
  const redVars = TABLE.map(
    ({ blue, red }) => `--m-${blue.replace("#", "")}:${red};`
  ).join("\n");
  const yellowVars = TABLE.map(
    ({ blue, yellow }) => `--m-${blue.replace("#", "")}:${yellow};`
  ).join("\n");

  return (
    <style>{`
  ${cssRules}

  /* 🔍 Hover highlight for interactive GC areas */
  g[role="button"]:hover path {
    filter: brightness(10.15);
    transition: filter 0.15s ease-out;
  }

  /* Palettes */
  [data-status="blue"] {
    ${blueVars}
  }
  [data-status="red"] {
    ${redVars}
  }
  [data-status="yellow"] {
    ${yellowVars}
  }

  /* Optional: blink animation (red-blink) */
  @keyframes blinkStatus {
    0% { ${redVars} }
    100% { ${blueVars} }
  }
  [data-status="red-blink"] {
    animation: blinkStatus 1s infinite alternate;
    ${redVars}
  }
`}</style>
  );
}
